import { Component, OnDestroy, OnInit } from '@angular/core';
import { Observable, Subscription } from 'rxjs';
import { LabService } from 'src/app/modules/lab/_services';
import { TranslationService } from 'src/app/modules/i18n/translation.service';
import { AuthService } from 'src/app/modules/auth/_services/auth.service';
import { AuthModel } from 'src/app/modules/auth/_models/auth.model';
import { DeleteAccountModalComponent } from './delete-account-modal/delete-account-modal.component';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { ChangePasswordComponent } from '../change-password/change-password.component';

@Component({
  selector: 'app-patient-profile',
  templateUrl: './profile-settings.component.html',
  styleUrls: ['./profile-settings.component.scss']
})
export class ProfileSettingsComponent implements OnInit, OnDestroy {
  isLoading$: Observable<boolean>;
  private subscriptions: Subscription[] = []; 
  language: any;
  user$: Observable<AuthModel>;
  UserId;
  roles:any[]=[];
  constructor(public LabService: LabService, private modalService: NgbModal,
    private translationService: TranslationService, private auth: AuthService) {
    this.user$ = this.auth.currentUserSubject.asObservable();
  }
  ngOnInit(): void {
    this.user$.subscribe(res => {
      if (res.userId) {
        this.UserId = res.userId;
        this.roles = res.roles;
      }
    })
    this.language = this.translationService.getSelectedLanguage();
    this.isLoading$ = this.LabService.isLoading$;
  }

  DeleteAccount() {
    const modalRef = this.modalService.open(DeleteAccountModalComponent);
    //modalRef.componentInstance.PatientId = this.UserId
  }
  ChangePassword() {
    const modalRef = this.modalService.open(ChangePasswordComponent);
    modalRef.componentInstance.roles = this.roles;
  }
  ngOnDestroy() {
    this.subscriptions.forEach((sb) => sb.unsubscribe());
  }
}
